
<template>
    <div class="panel-hdr bg-primary-500 bg-success-gradient">
        <h2>
            <span class="icon-stack fs-xxl mr-2">
                <i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
                <i class="base base-7 icon-stack-2x opacity-100 color-primary-400"></i>
                <i class="fal fa-cog icon-stack-1x opacity-100 color-white fa-spin"></i>
            </span>
            {{this.title}}
        </h2>
        <div class="panel-toolbar">
            <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            <button class="btn btn-icon btn-sm btn-danger mr-1 shadow-0 waves-effect waves-themed mr-2 ml-2" v-if="button_plus" v-on:click="button_action_emit">
                <i class="fal fa-plus"></i>
            </button>
        </div>
    </div>
</template>


<script>
export default {
    name: "make_doc_title",
    props : {
        title : {
            type : String
        },
        button_plus : {
            type : Boolean,
            default : false,
        },
        button_action: {
            type : String,
            default :"",
        },
    },
    methods : {
        button_action_emit() {
            EventBus.$emit(this.button_action);
        }
    }
}
</script>



<style scoped>

</style>